export enum PageTypeEnum {
	Swift247 = "c2c-order-payment",
	CargoDirect = 'order-bill',
}
